import React from 'react';

const Loader = () => {
  return (
    <div data-component-id="src/components/ui/Loader.tsx:5:4" data-component-path="src/components/ui/Loader.tsx" data-component-line="5" data-component-file="Loader.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-full%20h-full%22%7D" className="flex items-center justify-center w-full h-full">
      <div data-component-id="src/components/ui/Loader.tsx:6:6" data-component-path="src/components/ui/Loader.tsx" data-component-line="6" data-component-file="Loader.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-spin%20rounded-full%20h-10%20w-10%20border-4%20border-solid%20border-%5B%232A5BD7%5D%20border-t-transparent%22%7D"
        className="animate-spin rounded-full h-10 w-10 border-4 border-solid border-[#2A5BD7] border-t-transparent"
        role="status"
      />
    </div>
  );
};

export default Loader;
